/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Table, Button, Icon, Segment, Header } from 'semantic-ui-react'
import Axios from 'axios';
import moment from 'moment';

import APP_CONSTANTS from '../../config/constants';
import LoadingPlaceholder from '../placeholderComponent/loadingPlaceholder'
import CheckListActionButton from './checklistActionButton'
import AgGridTable from '../agGridComponent/agGridTable'


const CheckListTable = (props) => {
    const [items, setitems] = useState([])
    const [isLoaded, setisLoaded] = useState(false)

    const [ isUpdated, setisUpdated ] = useState(false)
    let getUpdate = (data) => {
        if (data) {
            setisUpdated(!isUpdated)
        }
    }

    const [ searchValue, setsearchValue ] = useState('')
    let handleSearch = (e, data) => {
        setsearchValue(data.value)
    }

    useEffect(() => {
        setisLoaded(false)
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let roleId = localStorage.getItem('roleId')
        let data = JSON.stringify
            ({
                api_token: token,
                customerNo: customerNo,
                userId: userId
            })
        Axios.post(`${APP_CONSTANTS.BASE_URL}fleet/checklist/getCheckList`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        }).then((response => {
            // console.log(response.data.data)
            setitems(response.data.data)
            setisLoaded(true)
        }))
            .catch(error => {
                console.log(error)
                setisLoaded(true)
            })
    }, [])

    if (items && items.length === 0 && isLoaded === false) {
        return (
            <>
                <LoadingPlaceholder />
            </>   
        )
    } else {

        let columnDefs = [
            { headerName: 'Checklist No.', field: 'checklistNo', tooltipField: 'checklistNo', enableRowGroup: true, enablePivot: true },
            { headerName: 'Vehicle No.', field: 'vehicleNo', tooltipField: 'vehicleNo', enableRowGroup: true, enablePivot: true },
            { headerName: 'No. Of Problems', field: 'problems', tooltipField: 'problems', enableRowGroup: true, enablePivot: true },
            { headerName: 'Branch', field: 'branch', tooltipField: 'branch', enableRowGroup: true, enablePivot: true },
            { headerName: 'Created By', field: 'cby', tooltipField: 'cby', enableRowGroup: true, enablePivot: true },
            { headerName: 'Created Date', field: 'cdt', tooltipField: 'cdt', enableRowGroup: true, enablePivot: true },
            { headerName: 'Updated By', field: 'uby', tooltipField: 'uby', enableRowGroup: true, enablePivot: true },
            { headerName: 'Updated Date', field: 'udt', tooltipField: 'udt', enableRowGroup: true, enablePivot: true },
            { headerName: 'Edit/Delete', field: 'edit', cellRenderer: 'actionRenderer', pinned: "right" },
        ]

        let rowData = []
        items.map((object, index) => {
            let temp = {}
            temp.checklistNo = object.checkListNumber.toUpperCase()
            temp.checkListId = object.checkListId
            temp.vehicleNo = object.vehicle_obj ? object.vehicle_obj.vehicleNo : ''
            temp.problems = object.noOfProblems
            temp.branch = object.branch_obj ? object.branch_obj.branchName : ''
            temp.cby = object.createdByName
            temp.cdt = moment(object.createdOn).format("DD-MM-YYYY hh:mm:ss")
            temp.uby = object.updatedByName
            temp.udt = object.updatedOn ? moment(object.updatedOn).format("DD-MM-YYYY hh:mm:ss") : ''
            rowData[index] = temp
        })

        let frameworkComponents = {
            actionRenderer: CheckListActionButton,
        }

        return (
            <React.Fragment>
                <div className="ag-theme-material agOver">
                    <AgGridTable
                        columnDefs={columnDefs}
                        rowData={rowData}
                        searchValue={searchValue}
                        extraComponents={frameworkComponents}
                        reload={getUpdate}
                        link="/add-checklist"
                        hiddenNewPopupBtn={true}
                        hiddenImportPopupBtn={true}
                        BaseUrl={props}
                        titleBarTitle="Checklist"
                        handleSearch={handleSearch}
                    />
                </div>
            </React.Fragment>
        )


    }
}

export default CheckListTable
